import React, { useEffect, useRef } from "react";
import { loadLeaflet } from "./leafletLoader";

export default function USAMapCDN(props) {
  var mapRef = useRef(null);
  var containerRef = useRef(null);

  useEffect(function () {
    var cancelled = false;
    loadLeaflet().then(function (L) {
      if (cancelled || !containerRef.current) return;

      // Limpia mapa previo
      if (mapRef.current) {
        try { mapRef.current.remove(); } catch (e) {}
        mapRef.current = null;
      }

      // Crea mapa
      var map = L.map(containerRef.current, {
        zoomControl: false,
        attributionControl: false,
        minZoom: 3,
        maxZoom: 18
      });
      map.setView([37.8, -96], 4);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { attribution: "© OpenStreetMap" })
        .addTo(map);

      L.control.zoom({ position: "bottomright" }).addTo(map);

      // Dibuja puntos (si vienen)
      var pts = (props && props.points && Array.isArray(props.points)) ? props.points : [];
      for (var i = 0; i < pts.length; i++) {
        var p = pts[i] || {};
        var lat = Number(p.lat), lng = Number(p.lng);
        if (isNaN(lat) || isNaN(lng)) continue;

        var value = Number(p.value || 0);
        var r = 6;
        if (value > 0) r = Math.max(6, Math.min(24, Math.sqrt(value)));

        var circle = L.circleMarker([lat, lng], {
          radius: r,
          stroke: true,
          weight: 1,
          opacity: 0.9,
          color: "#ae2447ff",
          fillColor: "#d42d57ff",
          fillOpacity: 0.35
        }).addTo(map);

        var label = (p.label ? String(p.label) : "Ubicación") + (value ? "<br/>Valor: " + value : "");
        circle.bindPopup(label);
      }

      if (props && typeof props.onReady === "function") {
        try { props.onReady(map); } catch (e) {}
      }

      mapRef.current = map;
    }).catch(function (e) {
      console.error("Leaflet CDN error:", e);
    });

    return function () {
      cancelled = true;
      if (mapRef.current) {
        try { mapRef.current.remove(); } catch (e) {}
        mapRef.current = null;
      }
    };
  }, [props]);

  return <div ref={containerRef} className="usa-map rounded-3" />;
}
